import React from "react";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";
import { GenericProgressBar } from "../../../components/GenericProgressBar";

const propTypes = {
  /**
   * Number of configured postures
   */
  configured: PropTypes.number,
  /**
   * Number of partially configured postures
   */
  partiallyConfigured: PropTypes.number,
  /**
   * Number of not configured postures
   */
  notConfigured: PropTypes.number,
  /**
   * Number of resolved postures
   */
  resolved: PropTypes.number,
  /**
   * Number of not measured postures
   */
  notMeasured: PropTypes.number,
  /**
   * If true, shows title
   */
  showTitle: PropTypes.bool,
};

const defaultProps = {
  configured: 0,
  partiallyConfigured: 0,
  notConfigured: 0,
  resolved: 0,
  notMeasured: 0,
  showTitle: true,
};

function PostureComplianceStatus(props) {
  const {
    configured,
    partiallyConfigured,
    notConfigured,
    resolved,
    notMeasured,
    showTitle,
  } = props;
  const intl = useIntl();

  return (
    <GenericProgressBar
      title={showTitle ? "SECURE.COMPLIANCE_STATUS" : undefined}
      values={[
        configured,
        partiallyConfigured,
        notConfigured,
        resolved,
        notMeasured,
      ]}
      valueLabels={[
        intl.formatMessage({ id: "SECURE.POSTURE.CONFIGURED" }),
        intl.formatMessage({
          id: "SECURE.POSTURE.PARTIALLY_CONFIGURED",
        }),
        intl.formatMessage({
          id: "SECURE.POSTURE.NOT_CONFIGURED",
        }),
        intl.formatMessage({ id: "SECURE.POSTURE.RESOLVED" }),
        intl.formatMessage({ id: "SECURE.POSTURE.NOT_MEASURED" }),
      ]}
      colors={["#66ca86", "#ffc000", "#ff7470", "#3399ff", "#e1e1ef"]}
      showLegendFooter
      flexGrow={8}
      isMultiValueProgressBar
    />
  );
}

PostureComplianceStatus.propTypes = propTypes;
PostureComplianceStatus.defaultProps = defaultProps;

export default PostureComplianceStatus;
